/**
 * 缓存说明:工单操作项缓存
 */
import vm from '@/cache/storeTools.js'
import itemApi from '@/components/api/order/flowApi.js'

var basestate = {
	itemTemplateTree:undefined
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getItemTemplateTree(state, getters) {
				if (state.itemTemplateTree == undefined) {
					store.commit('getItemTemplateTree')
				}
				return state.itemTemplateTree
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getItemTemplateTree(state) {
			itemApi.getItemTemplateTree(respon => {
				vm.Vue.set(state, 'itemTemplateTree', respon)
			})
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
